/**
 * Shared form behaviors extracted from admin, applicant, and backoffice.
 */

export function initSalaryToggle(checkboxId, minId, maxId) {
    $(`#${checkboxId}`).on('change', function () {
        if ($(this).is(':checked')) {
            $(`#${minId}`).attr('disabled', 'disabled')
            $(`#${maxId}`).attr('disabled', 'disabled')
        } else {
            $(`#${minId}`).removeAttr('disabled')
            $(`#${maxId}`).removeAttr('disabled')
        }
    })
}

$(() => {
    // Autosubmit forms
    $('form.autosubmit').on('change', function () {
        $(this).submit()
    })

    // Modal auto-open
    $('.modal[data-open=true]').modal('show')

    // Select hide neighbours
    $('select.js-hide-neighbours')
        .on('change', function () {
            const currentValue = $(this).val()

            $(this)
                .parents('.row')
                .find('[data-display-if]')
                .each(function (index, input) {
                    const values = $(input).data('display-if').split(' ')

                    if (values.includes(currentValue)) {
                        $(input).removeClass('d-none')
                    } else {
                        $(input).addClass('d-none')
                    }
                })
        })
        .change()

    // Nationality sort
    $('select[name=nationality_id]').each((idx, el) => {
        if ($(el).val() == '') {
            $(el).find($(el).find('option.nationality-F')).insertBefore($(el).find('option:eq(1)'))
        }
    })

    // Birth country show/hide department
    if ($('select[name=birth_country_id]').find('option:selected').text() != 'France') {
        $('select[name=birth_department_id]').parent().addClass('d-none')
    }

    $('select[name=birth_country_id]').each((idx, el) => {
        if ($(el).val() == '') {
            $(el).find($(el).find('option.birthCountry-FR')).insertBefore($(el).find('option:eq(1)'))
        }

        $(el).on('change', event => {
            if ($(event.target).find('option:selected').text() == 'France') {
                $('select[name=birth_department_id]').parent().removeClass('d-none')
            } else {
                $('select[name=birth_department_id]').parent().addClass('d-none')
            }
        })
    })

    // DiscoveredUsBy toggle
    $('#DiscoveredUsBy').on('change', function () {
        const options = Array.from(this.selectedOptions)
        const isOther = options.some(option => option.getAttribute('data-type') === 'Autre :')
        if (isOther) {
            $('#DiscoveredOther').toggleClass('d-none')
        } else {
            $('#DiscoveredOther').removeClass('d-block')
        }
    })

    // JobTemplateSalaryProfile toggle
    $('#JobTemplateSalaryProfile').on('change', function () {
        if ($('#JobTemplateSalaryProfile').is(':checked')) {
            $('#JobTemplateSalaryRangeMin').attr('disabled', 'disabled')
            $('#JobTemplateSalaryRangeMax').attr('disabled', 'disabled')
        } else {
            $('#JobTemplateSalaryRangeMin').removeAttr('disabled')
            $('#JobTemplateSalaryRangeMax').removeAttr('disabled')
        }
    })
})
